import React, { Fragment } from "react";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { IGeneralLedgerAccountResponse } from "../GeneralLedgerAccount.types";
import {
  DateCreated,
  DateModified,
  MaReportAccount,
  Settings,
  Update,
} from "../../../../../Constant";
import useGeneralLedgerAccountListController from "./useGeneralLedgerAccountList.controller";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";
import HeaderCard from "../../../../Common/Component/HeaderCard";
import DataTableServerFetchComponent from "../../../../Common/Component/DataTableServerFetchComponent";
import ViewModal from "../../../../Common/Component/ViewModal";
import { formatDateWithTimeZone } from "../../../../../_helper/dateHelper";
import InputProvider from "../../../Template/InputProvider";
import SwitchRows from "../../../Template/SwitchRows";

const GeneralLedgerAccountList = () => {
  const {
    loading,
    title,
    newBtn,
    data,
    tableColumns,
    useTableAction,
    viewModalOpen,
    setViewModalOpen,
    selectedRowData,
    editMode,
    handleView,
    editModalOpen,
    setEditModalOpen,

    inputErrors,
    glAccountFormSchema,
    glAccountInputData,
    handleGlAccountChange,

    maAccountFormSchema,
    maAccountInputData,
    handleMaAccountChange,

    switchLabels,
    setSwitchLabels,

    MaReportAccountTab,
    activeTab,
    handleTabClick,

    handleSubmit,
  } = useGeneralLedgerAccountListController();

  return (
    <Fragment>
      <Breadcrumbs parent={Settings} title={title} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard
                title={title}
                btnUrl={newBtn}
                span1={undefined}
                span2={undefined}
                mainClasses={undefined}
              />
              <CardBody>
                <DataTableServerFetchComponent
                  tabledata={data}
                  tableColumns={tableColumns}
                  isLoading={loading}
                  onView={handleView}
                  onDelete={undefined}
                  onEdit={undefined}
                  deleteMany={true}
                  clearSelect={false}
                  useTableAction={useTableAction}
                  addToDefaultAction={undefined}
                  useDefaultAction={true}
                  totalRows={undefined}
                  handlePerRowsChange={undefined}
                  handlePageChange={undefined}
                />

                <ViewModal
                  isOpen={viewModalOpen}
                  toggle={() => setViewModalOpen(!viewModalOpen)}
                  rowData={selectedRowData}
                  formFields={undefined}
                  editMode={editMode}
                  onEdit={undefined}
                  onSubmit={undefined}
                  modalTitle={undefined}
                >
                  {selectedRowData && (
                    <>
                      <Table>
                        <tbody>
                          <tr className="border-bottom-primary">
                            <th scope="row">Name</th>
                            <td>{selectedRowData.name}</td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">Code</th>
                            <td>{selectedRowData.number}</td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">Description</th>
                            <td>{selectedRowData.description}</td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">Status</th>
                            <td>
                              {selectedRowData.is_active ? (
                                <span className="badge badge-light-success">
                                  Active
                                </span>
                              ) : (
                                <span className="badge badge-light-danger">
                                  Inactive
                                </span>
                              )}
                            </td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">General Ledger Type</th>
                            <td>{selectedRowData.gl_type.name}</td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">General Ledger Class</th>
                            <td>{selectedRowData.gl_type.gl_class.name}</td>
                          </tr>

                          <tr className="border-bottom-primary">
                            <th scope="row">General Ledger Group</th>
                            <td>
                              {selectedRowData.gl_type.gl_class.gl_group.name}
                            </td>
                          </tr>

                          <tr className="border-bottom-secondary">
                            <th scope="row">{DateCreated}</th>
                            <td>
                              {formatDateWithTimeZone(
                                selectedRowData.created_at
                              )}
                            </td>
                          </tr>

                          <tr className="border-bottom-secondary">
                            <th scope="row">{DateModified}</th>
                            <td>
                              {formatDateWithTimeZone(
                                selectedRowData.updated_at
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </>
                  )}
                </ViewModal>

                <ViewModal
                  isOpen={editModalOpen}
                  toggle={() => setEditModalOpen(!editModalOpen)}
                  rowData={selectedRowData}
                  formFields={undefined}
                  editMode={editMode}
                  onEdit={undefined}
                  modalTitle={undefined}
                  onSubmit={undefined}
                >
                  <form onSubmit={handleSubmit}>
                    <InputProvider
                      schema={glAccountFormSchema}
                      inputData={glAccountInputData}
                      onChange={handleGlAccountChange}
                      errors={inputErrors.glAccountFormErrors}
                    />

                    <Row>
                      <Col sm={"12"}>
                        <Nav
                          className="border-tab nav-secondary nav-pills"
                          tabs
                        >
                          <NavItem>
                            <NavLink
                              href="#"
                              className={
                                activeTab === MaReportAccountTab ? "active" : ""
                              }
                              onClick={() => handleTabClick(MaReportAccountTab)}
                            >
                              <i className="icofont icofont-book"></i>
                              {MaReportAccount}
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>
                          <TabPane
                            className="fade show"
                            tabId={MaReportAccountTab}
                          >
                            <InputProvider
                              schema={maAccountFormSchema}
                              inputData={maAccountInputData}
                              onChange={handleMaAccountChange}
                              errors={inputErrors.maAccountFormErrors}
                            />
                          </TabPane>
                        </TabContent>
                      </Col>
                    </Row>

                    <SwitchRows
                      setSwitchFormDetails={setSwitchLabels}
                      switchFormDetails={switchLabels}
                    />

                    <div className="text-end">
                      <Button color="primary">{Update}</Button>
                    </div>
                  </form>
                </ViewModal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GeneralLedgerAccountList;

export const StatusRow = (row: IGeneralLedgerAccountResponse) => {
  return row.is_active ? (
    <span className="badge badge-light-success">Active</span>
  ) : (
    <span className="badge badge-light-danger">Inactive</span>
  );
};
